<app-header></app-header>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Acasa</a></li>
                <li>Tarife servicii</li>
            </ul>
            <h2>Tarife servicii</h2>
        </div>
    </div>
</div>

<div class="error-404-area">
    <div class="container">
        <div class="notfound">
            <div class="notfound-bg">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <h1>Oops!</h1>
            <h3>Tarife Servicii</h3>
            <p>Pagina pe care o cautati este in constructie</p>
            <!--<p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>-->
            <a routerLink="/" class="default-btn"><i class='bx bx-home-circle icon-arrow before'></i><span class="label">Inapoi acasa</span><i class="bx bx-home-circle icon-arrow after"></i></a>
        </div>
    </div>
</div>